export default __webpack_public_path__ + "static/media/logo.c07905c8.svg";